<template>
   <div>
      <!-- Campanita -->
      <div class="noti-button" @click="abrirModal(indiceActual)">
         <i class="bi bi-bell-fill blue-bell"></i>
         <span v-if="pendientes" class="badge-noti">
            {{ pendientes }}
         </span>
      </div>
      <!-- Modal -->
      <div v-if="mostrarModal" class="modal-overlay" @click.self="cerrarModal">
         <div class="modal-content">
            <img :src="logo" alt="Logo" class="logo" />
            <h1 class='text-red'>PiP INFORMA</h1>
            <h3 class="title-notification">{{ notificaciones[indiceActual]?.txtTitulo }}</h3>
            <div v-html="notificaciones[indiceActual]?.txtMessage"></div>

            <a v-if="notificaciones[indiceActual]?.blnDocument"
               :href="formatearURL(notificaciones[indiceActual].txtURLFile)" target="_blank" class="btn-documento">
               Ver documento
            </a>

            <div class="nav-botones">
               <span @click="anterior" class="arrow" :disabled="indiceActual === 0">←</span>
               <span @click="siguiente" class="arrow" :disabled="indiceActual === notificaciones.length - 1">→</span>
            </div>

            <button class="button-blue" @click="cerrarModal">Cerrar</button>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: 'CentroNotificaciones',
   inject: ["url", "urlStatics"],
   data() {
      return {
         logo: `${this.urlStatics}img/logo.svg`,
         mostrarModal: false,
         notificaciones: [],
         existNoti: false,
         indiceActual: 0,
         codigos: { mexico: 'MX', peru: 'PE', colombia: 'CO', centroamerica: 'CR' },
         lugar: null,
         vistas: new Set()
      };
   },

   watch: {
      '$route.params.nombre': {
         immediate: true,
         handler(newVal) {
            this.lugar = this.codigos[newVal] || 'MX';
            const hoy = new Date().toISOString().slice(0, 10);
            this.fetchNotificaciones(this.lugar);
            const data = localStorage.getItem(this.lugar);
            if (data) {
               const parsed = JSON.parse(data);
               if (parsed.fecha === hoy) {
                  this.vistas = new Set(parsed.vistas);
                  this.indiceActual = parsed.indiceActual || 0;
               } else {
                  // Si no es de hoy, reiniciamos
                  this.vistas = new Set();
                  this.indiceActual = 0;
                  localStorage.removeItem(this.lugar);
               }
            }
         }
      }
   },

   computed: {
      pendientes() {
         const pendientes = this.notificaciones.length - this.vistas.size;
         return pendientes > 0 ? pendientes : 0;
      }
   },

   methods: {
      abrirModal(indice) {
         if (this.existNoti) {
            this.mostrarModal = true;
            this.marcarVista(indice);
         }
      },

      cerrarModal() {
         this.mostrarModal = false;
      },

      marcarVista(indice) {
         this.vistas.add(indice);
         const hoy = new Date().toISOString().slice(0, 10);
         localStorage.setItem(this.lugar, JSON.stringify({
            vistas: Array.from(this.vistas),
            indiceActual: this.indiceActual,
            fecha: hoy
         }));
      },

      siguiente() {
         if (this.indiceActual < this.notificaciones.length - 1) {
            this.indiceActual++
            this.marcarVista(this.indiceActual)
         }
      },

      anterior() {
         if (this.indiceActual > 0) {
            this.indiceActual--
            this.marcarVista(this.indiceActual)
         }
      },

      formatearURL(url) {
         if (!url.startsWith("http")) {
            return "https://" + url;
         }
         return url;
      },

      async fetchNotificaciones(paisCodigo) {
         try {
            this.notificaciones = []
            this.vistas = new Set()
            this.indiceActual = 0;
            const response = await fetch(`${this.url}information`, {
               method: 'POST',
               headers: { 'Content-Type': 'application/json' },
               body: JSON.stringify({ txtCountry: paisCodigo, txtChannel: 'PiP_Informa' })
            });
            const result = await response.json();
            if (response.ok && result.StatusCode === 200) {
               this.existNoti = true
               this.notificaciones = result?.Data || [];
            } else {
               this.existNoti = false
               console.log(result.Data.Message)
            }
         } catch (err) {
            console.error('Error al obtener notificaciones:', err);
         }
      }
   }
};
</script>

<style scoped>
.noti-button {
   position: fixed;
   right: 8%;
   top: 5px;
   /* Asumiendo que tu navbar y carrusel suman ~110px */
   border-radius: 50%;
   width: 50px;
   height: 50px;
   color: white;
   font-size: 24px;
   display: flex;
   align-items: center;
   justify-content: center;
   cursor: pointer;
   z-index: 6;
}

.arrow {
   background: none;
   font-size: 2.3rem;
   color: grey;
   cursor: pointer;
   padding: 0.3rem 0.8rem;
}

.arrow:hover {
   color: white;
}

.badge-noti {
   position: absolute;
   top: 0;
   right: 0;
   background-color: red;
   color: white;
   border-radius: 999px;
   padding: 2px 6px;
   font-size: 10px;
   font-weight: bold;
}


.logo {
   height: 2em;
   width: auto;
   display: block;
   margin-left: 0;
}

.text-red {
   color: #DA291C;
   font-size: 1em;
   font-weight: 500;
}

.title-notification {
   font-weight: 500;
}

.blue-bell {
   color: #00B0F0;
}

.modal-overlay {
   z-index: 4;
   position: fixed;
   top: 0;
   left: 0;
   background-color: rgba(0, 0, 0, 0.7);
   width: 100%;
   height: 100%;
   display: flex;
   align-items: center;
   justify-content: center;
}

.modal-content {
   background-color: #1b1e3e;
   color: white !important;
   padding: 2em;
   border-radius: 10px;
   width: 90%;
   max-width: 500px;
   max-height: 80vh;
   overflow-y: auto;
   text-align: center;
}

.nav-botones {
   display: flex;
   justify-content: space-between;
}

.btn-documento {
   display: inline-block;
   padding: 0.6em 1.2em;
   margin-top: 1em;
   border: 2px solid white;
   background-color: transparent;
   color: white;
   text-decoration: none;
   border-radius: 8px;
   font-weight: bold;
   transition: all 0.3s ease;
}

.btn-documento:hover {
   box-shadow: 0 6px 12px rgba(180, 180, 180, 0.35);
   transform: translateY(-2px);
}


.cerrar {
   display: block;
   margin: 1em auto 0;
   background: #21244d;
   color: white;
   padding: 0.5em 1.5em;
   border: none;
   border-radius: 8px;
   cursor: pointer;
}

@media (max-width: 768px) {
   .noti-button {
      position: fixed;
      right: 14%;
      z-index: 5;
   }
}
</style>
